import React from 'react';

const COLORS = {
  blue:   { bg: '#dbeafe', color: '#2563eb' },
  green:  { bg: '#dcfce7', color: '#16a34a' },
  yellow: { bg: '#fef3c7', color: '#d97706' },
  red:    { bg: '#fee2e2', color: '#dc2626' },
  purple: { bg: '#ede9fe', color: '#7c3aed' },
  teal:   { bg: '#ccfbf1', color: '#0d9488' },
};

export default function StatsCard({ icon, label, value, color = 'blue' }) {
  const c = COLORS[color] || COLORS.blue;
  return (
    <div className="stat-card">
      <div className="stat-icon" style={{ background: c.bg, color: c.color }}>
        {icon}
      </div>
      <div className="stat-body">
        <div className="stat-value">{value ?? '—'}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
}
